<template>
        <div class="error-box" :class="{show:!backErrors}">
            {{backErrors}}
        </div>
</template>

<script>
    export default{
        data(){
            return{
                backErrors: this.backError
            }
        },
        props: {
            backError: {
                default:'',
                type: String
            }
        },
        components:{
        },
        methods: {

        },
        watch:{
            backError(data){
                this.backErrors = this.backError
                if(data){
                    if (this.toastTimer) clearTimeout(this.toastTimer);
                        this.toastTimer = setTimeout(() => {
                           this.backErrors = '';
                           this.$emit('clearError',this.backErrors)
                        }, 3000)
                }
            }
        }
    }

</script>
<style rel="stylesheet/less" lang="less" scoped>
    .error-box {
        width: 100%;
        height: 48px;
        line-height: 48px;
        border-radius: 3px;
        text-align: center;
        background-color: rgba(208,2,27,0.04);
        color: #D36B75;
        margin-bottom: 18px;
        font-size: 14px;
        margin-top: 16px;
        transition: height ease-in .2s;
    }
    .show {
        height: 0;
        font-size: 0;
        transition: all ease-in .2s;
    }

</style>



// WEBPACK FOOTER //
// errorMsg.vue?7e38382c